import config from "../config/config";
import { getToken } from "../utils/prefix"


  export async function announcement_create(data) {
    const res = await fetch(config.api_backend + `/announcement/create`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
  
  export async function announcement_update(data) {
    const res = await fetch(config.api_backend + `/announcement/update`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
  
  export async function announcement_delete(data) {
    const res = await fetch(config.api_backend + `/announcement/delete`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
  
  export async function get_all_announcement(data) {
    const res = await fetch(config.api_backend + `/announcement/all`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

  export async function get_suggest_announcement(data) {
    const res = await fetch(config.api_backend + `/announcement/suggestion`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        // Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

  export async function get_announcement(data) {
    const res = await fetch(config.api_backend + `/announcement/getAnnouncementById`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
      //   Authorization: getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

  export async function announcement_update_status(data) {
    const res = await fetch(config.api_backend + `/announcement/updateAnnouncementStatus`, {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        "x-access-token": getToken(),
        "Content-type": "application/json",
      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }

  export async function save_announcement_img(data) {
    var formdata = new FormData();
    formdata.append('announcement_id', data.announcement_id);
    formdata.append('user_id', data.user_id);
    formdata.append('file', data.file);
    const res = await fetch(config.api_backend + `/announcement/uploadAnnouncementImgFile`, {
      body: formdata,
      method: "POST",
      headers: {
      "x-access-token": getToken(),

      },
    });
  
    const dataRespone = await res.json();
    return dataRespone;
  }
 